/* eslint-disable react/prop-types */
import {
	forwardRef,
	JSXElementConstructor,
	ReactElement,
	useState,
	useRef,
	useContext,
	Suspense,
	useCallback
} from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Slide,
	Tab,
	Tabs
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { EligiblityDialogPropTypes } from "../../../../types/components/eligiblityDialogProps.types";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import calculateAge from "../../../../utils/commonFunctions/age";
import { VEB_ELIGIBLITY_MESSAGE } from "../../../../constants/eligiblityMessage";
import a11yProps from "../../../../constants/tabPanelProps/ayProps";
import { AuthContext, ThemeContext } from "../../../../contexts";
// import { Tab, Tabs } from "@material-ui/core";
// import  from "../../../shared/tabPanelComponent/ScrollTabPanel";
import ScrollTabPanel from "../../../shared/tabPanelComponent/ScrollTabPanel";
import EligibleDependentsGrid from "./eligibleDependentsGrid/EligibleDependentsGrid";
import {
	LazyEligibleDependentsGrid,
	LazyIneligibleDependentsGrid,
	LazyIneligibleRelationshipDependentsGrid
} from "../..";

const Transition: JSXElementConstructor<TransitionProps & { children: ReactElement<any, any> }> | undefined =
	forwardRef(function Transition(props, ref) {
		return <Slide direction="up" ref={ref} {...props} />;
	});

const EligiblityDialog = ({ eligiblityDialogProps }: EligiblityDialogPropTypes) => {
	const {
		openDialog,
		eligibleDependents,
		handleCloseEligiblityDialog,
		ineligibleRelationshipDependents,
		ineligibleDependents,
		VEBPlanName
	} = eligiblityDialogProps;
	const [tabLabel, setTabLabel] = useState(0);
	const { theme } = useContext(ThemeContext);
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const agGridRef = useRef<any>(null);

	const handleLabelChange = useCallback((event, value) => {
		setTabLabel(value);
	}, []);

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleAgeCellRenderer = ({ value }: { value: string }) => {
		return <div>{calculateAge(value, new Date())}</div>;
	};

	// const handleIneligibleDependentCellRenderer = () => {
	// 	return <div>{VEB_ELIGIBLITY_MESSAGE[VEBPlanName]}</div>;
	// };

	return (
		<div>
			<Dialog
				style={{ zIndex: 5000 }}
				open={openDialog}
				TransitionComponent={Transition}
				keepMounted
				fullWidth
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogContent>
					<DialogContentText id="alert-dialog-slide-description">
						<Tabs
							value={tabLabel}
							onChange={handleLabelChange}
							TabIndicatorProps={{
								style: {
									border: "none",
									background: theme.primary_color
								}
							}}
							variant="scrollable"
							scrollButtons="auto"
							aria-label="scrollable auto tabs example"
							// className="glb-tab-panel"
						>
							<Tab
								label={"Eligible Dependents"}
								{...a11yProps(0)}
								className="glb-tab-label"
								style={{ color: theme.primary_color, fontWeight: "bold", fontSize: "1rem" }}
							/>
							<Tab
								label={"Ineligible Dependents"}
								{...a11yProps(1)}
								className="glb-tab-label"
								style={{ color: theme.primary_color, fontWeight: "bold", fontSize: "1rem" }}
							/>
							<Tab
								label={"Ineligible Relationships"}
								{...a11yProps(2)}
								className="glb-tab-label"
								style={{ color: theme.primary_color, fontWeight: "bold", fontSize: "1rem" }}
							/>
						</Tabs>
						<ScrollTabPanel value={tabLabel} index={0}>
							<Suspense fallback={<div />}>
								<LazyEligibleDependentsGrid
									eligibleDependents={eligibleDependents}
									VEBPlanName={VEBPlanName}
								/>
							</Suspense>
						</ScrollTabPanel>
						<ScrollTabPanel value={tabLabel} index={1}>
							<Suspense fallback={<div />}>
								<LazyIneligibleDependentsGrid
									ineligibleDependents={ineligibleDependents}
									VEBPlanName={VEBPlanName}
								/>
							</Suspense>
						</ScrollTabPanel>
						<ScrollTabPanel value={tabLabel} index={2}>
							<Suspense fallback={<div />}>
								<LazyIneligibleRelationshipDependentsGrid
									ineligibleRelationshipDependents={ineligibleRelationshipDependents}
									VEBPlanName={VEBPlanName}
								/>
							</Suspense>
						</ScrollTabPanel>
					</DialogContentText>
				</DialogContent>
				<DialogActions className="custom-dialog-action-button-container">
					<Button
						variant="contained"
						onClick={handleCloseEligiblityDialog}
						style={{
							backgroundColor: "#3a4652", //"#44b700" --> Green Color
							letterSpacing: "1px",
							fontSize: "0.7rem",
							fontWeight: "bold",
							color: "#ffff",
							marginRight: 10,
							marginLeft: 5
						}}
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default EligiblityDialog;
